// @generated by protobuf-ts 2.8.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/accounts/v1/accounts.proto" (package "c1.api.accounts.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import type { RpcTransport } from "@protobuf-ts/runtime-rpc";
import type { ServiceInfo } from "@protobuf-ts/runtime-rpc";
import { Accounts } from "./accounts";
import type { GetRUMResponse } from "./accounts";
import type { GetRUMRequest } from "./accounts";
import type { SignupResponse } from "./accounts";
import type { SignupRequest } from "./accounts";
import type { Tenant } from "./accounts";
import type { GetTenantRequest } from "./accounts";
import type { Installation } from "./accounts";
import type { GetInstallationRequest } from "./accounts";
import { stackIntercept } from "@protobuf-ts/runtime-rpc";
import type { ListAuthBackendsResponse } from "./accounts";
import type { ListAuthBackendsRequest } from "./accounts";
import type { UnaryCall } from "@protobuf-ts/runtime-rpc";
import type { RpcOptions } from "@protobuf-ts/runtime-rpc";
/**
 * @generated from protobuf service c1.api.accounts.v1.Accounts
 */
export interface IAccountsClient {
    /**
     * @generated from protobuf rpc: ListAuthBackends(c1.api.accounts.v1.ListAuthBackendsRequest) returns (c1.api.accounts.v1.ListAuthBackendsResponse);
     */
    listAuthBackends(input: ListAuthBackendsRequest, options?: RpcOptions): UnaryCall<ListAuthBackendsRequest, ListAuthBackendsResponse>;
    /**
     * @generated from protobuf rpc: GetInstallation(c1.api.accounts.v1.GetInstallationRequest) returns (c1.api.accounts.v1.Installation);
     */
    getInstallation(input: GetInstallationRequest, options?: RpcOptions): UnaryCall<GetInstallationRequest, Installation>;
    /**
     * @generated from protobuf rpc: GetTenant(c1.api.accounts.v1.GetTenantRequest) returns (c1.api.accounts.v1.Tenant);
     */
    getTenant(input: GetTenantRequest, options?: RpcOptions): UnaryCall<GetTenantRequest, Tenant>;
    /**
     * @generated from protobuf rpc: Signup(c1.api.accounts.v1.SignupRequest) returns (c1.api.accounts.v1.SignupResponse);
     */
    signup(input: SignupRequest, options?: RpcOptions): UnaryCall<SignupRequest, SignupResponse>;
    /**
     * @generated from protobuf rpc: GetRUM(c1.api.accounts.v1.GetRUMRequest) returns (c1.api.accounts.v1.GetRUMResponse);
     */
    getRUM(input: GetRUMRequest, options?: RpcOptions): UnaryCall<GetRUMRequest, GetRUMResponse>;
}
/**
 * @generated from protobuf service c1.api.accounts.v1.Accounts
 */
export class AccountsClient implements IAccountsClient, ServiceInfo {
    typeName = Accounts.typeName;
    methods = Accounts.methods;
    options = Accounts.options;
    constructor(private readonly _transport: RpcTransport) {
    }
    /**
     * @generated from protobuf rpc: ListAuthBackends(c1.api.accounts.v1.ListAuthBackendsRequest) returns (c1.api.accounts.v1.ListAuthBackendsResponse);
     */
    listAuthBackends(input: ListAuthBackendsRequest, options?: RpcOptions): UnaryCall<ListAuthBackendsRequest, ListAuthBackendsResponse> {
        const method = this.methods[0], opt = this._transport.mergeOptions(options);
        return stackIntercept<ListAuthBackendsRequest, ListAuthBackendsResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GetInstallation(c1.api.accounts.v1.GetInstallationRequest) returns (c1.api.accounts.v1.Installation);
     */
    getInstallation(input: GetInstallationRequest, options?: RpcOptions): UnaryCall<GetInstallationRequest, Installation> {
        const method = this.methods[1], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetInstallationRequest, Installation>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GetTenant(c1.api.accounts.v1.GetTenantRequest) returns (c1.api.accounts.v1.Tenant);
     */
    getTenant(input: GetTenantRequest, options?: RpcOptions): UnaryCall<GetTenantRequest, Tenant> {
        const method = this.methods[2], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetTenantRequest, Tenant>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: Signup(c1.api.accounts.v1.SignupRequest) returns (c1.api.accounts.v1.SignupResponse);
     */
    signup(input: SignupRequest, options?: RpcOptions): UnaryCall<SignupRequest, SignupResponse> {
        const method = this.methods[3], opt = this._transport.mergeOptions(options);
        return stackIntercept<SignupRequest, SignupResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GetRUM(c1.api.accounts.v1.GetRUMRequest) returns (c1.api.accounts.v1.GetRUMResponse);
     */
    getRUM(input: GetRUMRequest, options?: RpcOptions): UnaryCall<GetRUMRequest, GetRUMResponse> {
        const method = this.methods[4], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetRUMRequest, GetRUMResponse>("unary", this._transport, method, opt, input);
    }
}
